import { SET_BB_READY } from "../actions/mortgageCalc"

const mortgageCalc = (state = {bbReady: false}, action) => {
    switch(action.type) {
        case SET_BB_READY:
            return {...state, bbReady: action.bbReady}
        default:
            return state
    }
}

export default mortgageCalc